/* Product media gallery — thumbnail switching + image zoom (lightbox).
   Active thumb gets the 2px coral border (.is-active); main image swaps in place.
   Zoom: [data-zoom-open] or a click on the main image opens [data-zoom-modal]
   (sections/main-product.liquid) at up to 2400px; fit-to-screen by default,
   [ 1:1 ] / a click on the image toggles native size with scrolling.
   Keys: Esc closes, ←/→ step through the product media. */
(function () {
  'use strict';

  function init() {
    var thumbsRoot = document.querySelector('[data-thumbs]');
    var mainImage = document.querySelector('[data-main-image]');
    if (!mainImage) return;

    var thumbs = thumbsRoot ? Array.prototype.slice.call(thumbsRoot.querySelectorAll('[data-thumb]')) : [];

    function select(thumb) {
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
      mainImage.src = thumb.getAttribute('data-full-src');
      var srcset = thumb.getAttribute('data-full-srcset');
      if (srcset) mainImage.srcset = srcset;
      var zoomSrc = thumb.getAttribute('data-zoom-src');
      if (zoomSrc) mainImage.setAttribute('data-zoom-src', zoomSrc);
    }

    if (thumbsRoot) {
      thumbsRoot.addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-thumb]');
        if (thumb) select(thumb);
      });

      /* Preload neighbours on hover for a snappy swap */
      thumbsRoot.addEventListener('mouseover', function (event) {
        var thumb = event.target.closest('[data-thumb]');
        if (!thumb) return;
        var img = new Image();
        img.src = thumb.getAttribute('data-full-src');
      });
    }

    initZoom(mainImage, thumbs, select);
  }

  function initZoom(mainImage, thumbs, select) {
    var modal = document.querySelector('[data-zoom-modal]');
    var trigger = document.querySelector('[data-zoom-open]');
    if (!modal) return;

    var panel = modal.querySelector('.dm-zoom__panel');
    var body = modal.querySelector('[data-zoom-body]');
    var image = modal.querySelector('[data-zoom-image]');
    var title = modal.querySelector('[data-zoom-title]');
    var toggle = modal.querySelector('[data-zoom-toggle]');
    var prev = modal.querySelector('[data-zoom-prev]');
    var next = modal.querySelector('[data-zoom-next]');

    var items = thumbs.length
      ? thumbs.map(function (t) {
          return { src: t.getAttribute('data-zoom-src'), alt: t.getAttribute('data-zoom-alt') || '' };
        })
      : [{ src: mainImage.getAttribute('data-zoom-src'), alt: mainImage.alt }];
    var index = 0;
    var returnFocus = null;

    if (items.length < 2) {
      prev.hidden = true;
      next.hidden = true;
    }

    function setActual(on) {
      modal.classList.toggle('is-actual', on);
      toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
      toggle.textContent = on ? '[ FIT ]' : '[ 1:1 ]';
      body.scrollTop = 0;
      body.scrollLeft = 0;
    }

    function show(i) {
      index = (i + items.length) % items.length;
      setActual(false);
      image.src = items[index].src;
      image.alt = items[index].alt;
      title.textContent = '>_ VIEW ' + (index + 1) + '/' + items.length;
    }

    function open() {
      var active = thumbs.filter(function (t) { return t.classList.contains('is-active'); })[0];
      returnFocus = document.activeElement;
      show(active ? thumbs.indexOf(active) : 0);
      modal.hidden = false;
      document.body.classList.add('dm-no-scroll');
      panel.focus();
    }

    function close() {
      modal.hidden = true;
      document.body.classList.remove('dm-no-scroll');
      /* Leave the gallery on the image the visitor last looked at */
      if (thumbs[index]) select(thumbs[index]);
      if (returnFocus && returnFocus.focus) returnFocus.focus();
    }

    if (trigger) {
      trigger.hidden = false;
      trigger.addEventListener('click', open);
    }
    mainImage.classList.add('is-zoomable');
    mainImage.addEventListener('click', open);

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-zoom-close]')) close();
    });
    prev.addEventListener('click', function () { show(index - 1); });
    next.addEventListener('click', function () { show(index + 1); });
    toggle.addEventListener('click', function () { setActual(!modal.classList.contains('is-actual')); });
    image.addEventListener('click', function () { setActual(!modal.classList.contains('is-actual')); });

    document.addEventListener('keydown', function (event) {
      if (modal.hidden) return;
      if (event.key === 'Escape') close();
      else if (event.key === 'ArrowLeft' && items.length > 1) show(index - 1);
      else if (event.key === 'ArrowRight' && items.length > 1) show(index + 1);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
